export default {
  cn: {
    tableModelUserList: {
      th: {
        WalletBalance: "钱包余额",
        funds: '出入金记录',
        loginId: "登录账号",
        IBCode: "IB代码",
        order: "订单",
        dealTime: '交易时间',
        annotation: '注释',
        nodeCode: '代理代码',
        money: "金额",
        ReportType: "报表类型",
        accountName: "账户名称",
        group: "团队",
        superiorAccount: "上级MT4账号",
        superiorCode: "上级IB代码",
        phone: "电话",
        email: "电子邮箱",
        remark: "备注",
        last_update: "最后修改时间",
        comment: "上级代码",
        superAgentNum: "上级代理账号",
        superAgentCode: "上级代理代码",
        lowerAgentTotal: "下级代理总数",
        generalClientTotal: "普通客户总数",
        margin: "已用预支付",
        marginfree: "可用预付款",
        marginlevel: "预付款比例",
        status: "状态",
        equity: "净值",
        balance: "余额",
        accType: "类型",
        mt4_sync_deposits_sum: "入金",
        mt4_sync_withdrawal_sum: "出金",
        commission_sum: "佣金",
        commission_sum2: "代理佣金",
        profit_sum: "盈亏",
        swaps_sum: "利息",
        volume_sum: "交易量",
        balance2: "净入金",
        balance3: "余额",
        newAgentCount: "新代理",
        newClientCount: "新客户",
        mt4_sync_transfer_ins_sum: "资金转入",
        summary: "总结",
        officeState: {
          name: "职员状态",
          countryArr: [
            {text: "全职", value: "F"},
            {text: "兼职", value: "P"},
            {text: "离职", value: "D"}
          ]
        },
        loginType: {
          name: "类型",
          typeArr: [
            {text: '系统', value: "UN"},
            {text: '公司', value: "C"},
            {text: '国家', value: "N"},
            {text: '地区', value: "R"},
            {text: '办事处', value: "O"},
            {text: '经理', value: "M"},
            {text: '销售', value: "SL"},
            {text: '代理', value: "IB"},
            {text: '客户', value: "CL"},
          ]
        },
        Role_ID:"角色ID",
        Desc:"描述",
        operation: "操作"
      },
      crumbs: {
        userList: '用户列表',
        authList: '权限管理',
        accountList: '账户列表',
        ibList: "代理名单",
        dailyReport: "每日总结",
        clientList: "客户名单",
        warehouse: "仓库总结"
      },
      dropdown: {
        text: "",
        list: {
          loginId: "登录账号",
          userName: "账户名称",
          IBcode: "IB代码",
          phone: "电话",
          email: "电子邮箱",
          certificateId: "证件号码",
          superiorMT: "上级MT4账号",
          superiorMTIB: "上级IB代码"
        }
      },
      show: "显示",
      num: "数",
      clauses: "条目",
      clauses_text: "显示条目数",
      all: "全部",
      amount: "总数",
      present: "当前",
      refreshData: "全部数据",
      downloadExcelForms: "下载Excel",
      addAccount: "添加账户",
      deletedData: "删除数据",
      addRole: "添加角色",
      deleteRole: "删除角色",
      roleName:"角色名称",
      roleDesc:"角色描述",
      confirmDelete: "确认删除",
      search: "搜索",
      nodata: "没有查询到数据",
      getBack: "返回上一级",
      tier: "代理层级",
      total: "合计",
    }
  },
  hk: {
    tableModelUserList: {
      th: {
        WalletBalance: "錢包餘額",
        funds: '出入金記錄',
        loginId: "登錄賬號",
        IBCode: "IB代碼",
        order: "訂單",
        dealTime: '交易時間',
        annotation: '注釋',
        nodeCode: '代理代碼',
        money: "金額",
        ReportType: "報表類型",
        accountName: "帳戶名稱",
        group: "團隊",
        superiorAccount: "上級MT4帳號",
        superiorCode: "上級IB代碼",
        phone: "電話",
        email: "電子郵箱",
        remark: "備註",
        last_update: "最後修改時間",

        comment: "上級代碼",
        superAgentNum: "上級代理賬號",
        superAgentCode: "上級代理代碼",
        lowerAgentTotal: "下級代理总数",
        generalClientTotal: "普通客戶總數",
        margin: "已用預付款",
        marginfree: "可用預付款",
        marginlevel: "預付款比例",
        status: "狀態",

        equity: "淨值",
        balance: "餘額",

        accType: "類型",
        mt4_sync_deposits_sum: "入金",
        mt4_sync_withdrawal_sum: "出金",
        commission_sum: "傭金",
        commission_sum2: "代理傭金",
        profit_sum: "盈虧",
        swaps_sum: "利息",
        volume_sum: "交易量",
        balance2: "淨入金",
        balance3: "餘額",
        newAgentCount: "新代理",
        newClientCount: "新客戶",
        mt4_sync_transfer_ins_sum: "資金轉入",
        summary: "總結",
        officeState: {
          name: "職員狀態",
          countryArr: [
            {text: "全職", value: "F"},
            {text: "兼職", value: "P"},
            {text: "離職", value: "D"}
          ]
        },
        loginType: {
          name: "類型",
          typeArr: [
            {text: '系統', value: "UN"},
            {text: '公司', value: "C"},
            {text: '國家', value: "N"},
            {text: '地區', value: "R"},
            {text: '辦事處', value: "O"},
            {text: '經理', value: "M"},
            {text: '銷售', value: "SL"},
            {text: '代理', value: "IB"},
            {text: '客戶', value: "CL"},
          ]
        },
        Role_ID:"角色ID",
        Desc:"描述",
        operation: "操作"
      },
      crumbs: {
        userList: '用戶列表',
        authList: '權限管理',
        accountList: '帳戶列表',
        ibList: "代理名單",
        dailyReport: "每日总结",
        clientList: "客戶名單",
        warehouse: "倉庫總結"
      },
      dropdown: {
        text: "",
        list: {
          loginId: "登錄帳號",
          userName: "帳戶名稱",
          IBcode: "IB代碼",
          phone: "電話",
          email: "電子郵箱",
          certificateId: "證件號碼",
          superiorMT: "上級MT4帳號",
          superiorMTIB: "上級IB代碼"
        }
      },
      show: "顯示",
      num: "數",
      clauses: "條目",
      clauses_text: "顯示條目數",
      all: "全部",
      amount: "總數",
      present: "當前",
      refreshData: "全部數據",
      downloadExcelForms: "下載Excel",
      addAccount: "添加帳戶",
      deletedData: "刪除數據",
      addRole: "添加角色",
      deleteRole: "删除角色",
      confirmDelete: "確認刪除",
      roleName:"角色名称",
      roleDesc:"角色描述",
      search: "搜索",
      nodata: "没有查询到数据",
      getBack: "返回上一級",
      tier: "代理層級",
      total: "合計"
    }
  },
  en: {
    tableModelUserList: {
      th: {
        WalletBalance: "Wallet Balance",
        funds: 'Entry and exit record',
        loginId: "User ID",
        IBCode: "IB Code",
        order: "Order",
        dealTime: 'Deal time',
        annotation: 'Annotation',
        nodeCode: 'nodeCode',
        money: "Amount of money",
        ReportType: "Report type",
        accountName: "User Name",
        group: "group",
        superiorAccount: "Superior MT4 Account",
        superiorCode: "Superior IB Code",
        phone: "Phone",
        email: "Email",
        remark: "Remark",
        last_update: "Last modification ",
        comment: "comment",
        superAgentNum: "superAgentNum",
        superAgentCode: "superAgentCode",
        lowerAgentTotal: "lowerAgentTotal",
        generalClientTotal: "generalClientTotal",
        margin: "margin",
        marginfree: "marginfree",
        marginlevel: "marginlevel",
        status: "status",
        equity: "equity",
        balance: "balance",
        accType: "Types of",
        mt4_sync_deposits_sum: "Into the gold",
        mt4_sync_withdrawal_sum: "Out of gold",
        commission_sum: "commission",
        commission_sum2: "Agency commission",
        profit_sum: "Profit and loss",
        swaps_sum: "interest",
        volume_sum: "Trading volume",
        balance2: "Net deposit",
        balance3: "Balance",
        newAgentCount: "newAgentCount",
        newClientCount: "newClientCount",
        mt4_sync_transfer_ins_sum: "Capital transfer",
        summary: "summary",
        officeState: {
          name: "Employee status",
          countryArr: [
            {text: "full time", value: "F"},
            {text: "part time", value: "P"},
            {text: "Leave", value: "D"}
          ]
        },
        loginType: {
          name: "Types of",
          typeArr: [
            {text: 'system', value: "UN"},
            {text: 'the company', value: "C"},
            {text: 'country', value: "N"},
            {text: 'area', value: "R"},
            {text: 'office', value: "O"},
            {text: 'manager', value: "M"},
            {text: 'Sales', value: "SL"},
            {text: 'IB', value: "IB"},
            {text: 'client', value: "CL"},
          ]
        },
        Role_ID:"Role_ID",
        Desc:"Desc",
        operation: "Operation"
      },
      crumbs: {
        userList: 'User List',
        accountList: 'account list',
        authList: 'auth list',
        ibList: "client list",
        dailyReport: "Daily summary",
        clientList: "Proxy list",
        warehouse: "Warehouse to summarize"
      },
      dropdown: {
        text: "",
        list: {
          loginId: "loginId",
          userName: "userName",
          IBcode: "IBcode",
          phone: "phone",
          email: "email",
          certificateId: "certificateId",
          superiorMT: "superiorMT",
          superiorMTIB: "superiorMTIB"
        }
      },
      show: "show",
      num: "num",
      clauses: "clauses",
      clauses_text: "Display",
      all: "all",
      amount: "amount",
      present: "present",
      refreshData: "Refresh",
      downloadExcelForms: "Download",
      addAccount: "Create user",
      deletedData: "Delete user",
      addRole: "addRole",
      deleteRole: "deleteRole",
      roleName:"roleName",
      roleDesc:"roleDesc",
      confirmDelete: "confirmDelete",
      search: "search",
      nodata: "No data was found",
      getBack: "Return to the next level",
      tier: "hierarchical agency",
      total: "Total"
    }
  }
};



// WEBPACK FOOTER //
// ./src/MultiLanguage/tableModel-user-list.js